import { Award, GraduationCap, BookMarked, Stethoscope } from "lucide-react";
import { PHOTOS } from "../../lib/clinic";

const CREDENCIALES = [
  {
    icon: Award,
    title: "Trayectoria",
    text: "Ex-Jefe de la Unidad de Cuidados Intensivos Cardiovasculares del Centro Médico ABC Observatorio — Torre de Cuidados Críticos y Quirúrgicos Annie Cass — y formación en Médica Sur.",
  },
  {
    icon: Stethoscope,
    title: "Especialidad Dual",
    text: "Cardiólogo y experto en el manejo integral del paciente cardiológico complejo.",
  },
  {
    icon: GraduationCap,
    title: "Formación",
    text: "Orgullosamente egresado de la Universidad Autónoma de Aguascalientes (UAA) y de la UNAM.",
  },
  {
    icon: BookMarked,
    title: "Autor de Referencia",
    text: "Co-autor de libros especializados en Dislipidemias y Prevención Cardiovascular — referencia nacional.",
  },
];

export const SobreDoctor = () => {
  return (
    <section id="doctor" data-testid="doctor-section" className="py-20 md:py-28 bg-[hsl(var(--cream))] bg-grain relative">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Photo column */}
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative">
              <div className="absolute -inset-4 bg-[hsl(var(--soft-red))]/10 rounded-[36px] -rotate-2" />
              <div className="relative rounded-3xl overflow-hidden border border-[hsl(var(--border))] shadow-soft">
                <img
                  src={PHOTOS.about}
                  alt="Dr. Luis Rodrigo González Azuara en su consultorio"
                  className="w-full h-[520px] object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -bottom-6 right-6 bg-[hsl(var(--navy))] text-[hsl(var(--cream))] rounded-2xl px-5 py-4 shadow-soft max-w-[260px]">
                <div className="text-[10px] uppercase tracking-[0.22em] opacity-70">Cédula profesional</div>
                <div className="font-serif-display text-lg mt-0.5">Especialista certificado</div>
                <div className="text-xs opacity-80 mt-1">CONACEM · Consejo Mexicano de Cardiología</div>
              </div>
            </div>
          </div>

          {/* Content column */}
          <div className="lg:col-span-7">
            <span className="text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--soft-red))] font-medium">
              · Sobre el Dr. González Azuara ·
            </span>
            <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--navy))] leading-[1.1]">
              Por qué confiar
              <br />
              <span className="italic font-light">tu corazón</span> aquí.
            </h2>
            <p className="mt-6 text-[hsl(var(--navy-soft))] text-base md:text-lg leading-relaxed max-w-2xl">
              Detrás de cada consulta hay 15 años de experiencia en los principales hospitales del país,
              y la convicción de que un buen diagnóstico empieza por escuchar — con tiempo, con paciencia,
              <em> como antes</em>.
            </p>

            <div className="mt-10 grid sm:grid-cols-2 gap-5">
              {CREDENCIALES.map((c, i) => (
                <div
                  key={c.title}
                  data-testid={`credencial-${i}`}
                  className="rounded-2xl bg-white border border-[hsl(var(--border))] p-5 transition-all hover:border-[hsl(var(--navy))] hover:shadow-soft"
                >
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-9 h-9 rounded-lg bg-[hsl(var(--navy))]/5 grid place-items-center">
                      <c.icon className="w-4 h-4 text-[hsl(var(--navy))]" strokeWidth={1.8} />
                    </div>
                    <h3 className="font-serif-display text-lg text-[hsl(var(--navy))]">{c.title}</h3>
                  </div>
                  <p className="text-sm text-[hsl(var(--navy-soft))] leading-relaxed">{c.text}</p>
                </div>
              ))}
            </div>

            {/* Quote block */}
            <blockquote className="mt-10 pl-6 border-l-2 border-[hsl(var(--soft-red))]" data-testid="doctor-quote">
              <p className="font-serif-display italic text-xl md:text-2xl text-[hsl(var(--navy))] leading-snug">
                "El mejor estudio nunca reemplaza una consulta donde el paciente se siente escuchado.
                Por eso explico todo, con dibujos si hace falta."
              </p>
              <footer className="mt-3 text-sm uppercase tracking-[0.18em] text-[hsl(var(--navy-soft))]">
                — Dr. Luis Rodrigo González Azuara
              </footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};
